module.exports = __webpack_public_path__ + "static/media/ARMAN-AI-02.797ad9b4.svg";